import { FaAngleRight } from "react-icons/fa";
import { FaPlus } from "react-icons/fa6";
import { FaMinus } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useState } from "react";

const HelpDeskFaq = () => {
  const [activeIndex, setActiveIndex] = useState(1);

  const faqItems = [
    {
      id: 1,
      question: "What does this garage management software do?",
      answer:
        "Our software helps garages streamline daily operations by managing customer details, service history, job cards, invoicing, and payment tracking—all in one platform.",
    },
    {
      id: 2,
      question: "Is the software easy to use for staff with limited technical knowledge?",
      answer:
        "Yes, the interface is designed to be simple and user-friendly, ensuring that even staff with minimal computer skills can use it efficiently.",
    },
    {
      id: 3,
      question: "Can I generate digital invoices and share them with customers?",
      answer:
        "Absolutely. The software allows you to create professional invoices and share them instantly via email.",
    },
    {
      id: 4,
      question: "Is customer support available if I face issues?",
      answer:
        "Yes, we provide dedicated customer support to assist you with setup, troubleshooting, and ongoing usage of the software.",
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  return (
    <>
      <section className="hd-faq-section pt-80 pb-40">
        <div className="container">
          <div className="row g-5 justify-content-center">
            <div className="col-xl-5 col-lg-8">
              <div className="hd-chat-box">
                <h3 className="text-white mb-3">
                  Need Help?
                  <br />
                  We're Here for You
                </h3>
                <p className="text-white mb-4">
                  Need assistance setting up, have a question, or facing an
                  issue? We're here to help! Access our detailed FAQs, get
                  step-by-step guides, or chat with our support team in real
                  time. Fast, friendly support whenever you need it, so your
                  garage keeps running smoothly.
                </p>
                <Link
                  to="#"
                  onClick={() =>
                    window.open("https://wa.me/919660035755", "_blank")
                  }
                  className="read-more-link text-warning"
                >
                  Chat with us Right Now <FaAngleRight className="ms-1" />
                </Link>
                {/* <Link
                  // href="/contact-us"
                  className="read-more-link text-warning"
                >
                  Chat with us Right Now <FaAngleRight className="ms-1" />
                </Link> */}
                <img
                  src="assets/img/help-desk/illustration.png"
                  alt="illustration"
                  className="img-fluid mt-4"
                />
              </div>
            </div>
            <div className="col-xl-7 col-lg-8 ">
              <div className="hd-faq-wrapper">
                <div
                  className="accordion hd-accordion hd-accordion2 mt-60"
                  id="hd_accordion2"
                >
                  {faqItems.map((item, index) => (
                    <div
                      className={`accordion-item ${activeIndex === index ? "active" : ""
                        }`}
                      key={item.id}
                    >
                      <div className="accordion-header">
                        <a
                          href={`#hd2_acc${item.id}`}
                          className={`d-flex justify-content-between ${activeIndex === index ? "" : "collapsed"
                            }`}
                          onClick={() => toggleAccordion(index)}
                          data-bs-toggle="collapse"
                        >
                          {item.question}
                          <span>
                            {activeIndex === index ? <FaMinus /> : <FaPlus />}
                          </span>
                        </a>
                      </div>
                      <div
                        className={`accordion-collapse collapse ${activeIndex === index ? "show" : ""
                          }`}
                        id={`hd2_acc${item.id}`}
                        data-bs-parent="#hd_accordion2"
                      >
                        <div className="accordion-body pt-0">
                          <p className="mb-0">{item.answer}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="container">
          <div
            className="bg-dark shadow-lg p-5 rounded-custom  mt-lg-4 mt-5"
            data-aos="fade-up"
            data-aos-delay="250"
          >
            <div className="row align-items-center justify-content-between">
              <div className="col-lg-7">
                <div className="cta-content">
                  <h3 className="mb-2">Have More Questions?</h3>
                  <p className="mb-lg-0 mb-xl-0">
                    Drop us a note and we’ll get back to you soon
                  </p>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="action-btns text-lg-end">
                  <Link 
                  // to="/contact-us" 
                  className="btn btn-secondary">
                    Mail Us
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </section>
    </>
  );
};

export default HelpDeskFaq;
